import { useForgotPasswordMutation } from "@mc-intranet/shared";
import { ArrowBack, MailOutline } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Button,
  Container,
  FormHelperText,
  Grid,
  InputAdornment,
  TextField
} from "@mui/material/";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";

import { useGraphQLClient } from "../../cache";
type FormData = {
  email: string;
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
  // loading: boolean;
  // login: (userName: string, password: string) => void;
}

const ForgotPasswordPage: React.FC<Props> = () => {
  const { client } = useGraphQLClient();
  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm<FormData>({
    defaultValues: {
      email: ""
    }
  });

  const {
    mutate: forgotPasswordMutation,
    isLoading: loading,
    isError: mutationError
  } = useForgotPasswordMutation(client);

  const onSubmit = (values: FormData) => {
    // console.log("Success:", values);
    const { email } = values;

    forgotPasswordMutation(
      { email },
      {
        onSuccess(data) {
          const ok = data?.forgotPassword?.ok;
          if (ok) {
            toast.success(
              "Richiesta avvenuta con successo.\n Riceverai il link nella tua casella di posta elettronica.",
              {
                position: toast.POSITION.TOP_CENTER
              }
            );
          }
        },
        onError: (error: any) => {
          toast.error(error?.response?.error.message, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      }
    );
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: {
          xs: "calc(100vh - 56px - 56px)",
          md: "calc(100vh - 69px - 56px)"
        },
        position: "relative",
        pb: 3
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        width="100%"
      >
        <Controller
          name="email"
          control={control}
          rules={{ required: "campo obbligatorio" }}
          render={({ field }) => (
            <TextField
              {...field}
              margin="normal"
              fullWidth
              label="Email"
              autoComplete="email"
              autoFocus
              error={!!errors.email}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MailOutline />
                  </InputAdornment>
                )
              }}
            />
          )}
        />
        {errors.email && (
          <FormHelperText error>{errors.email.message}</FormHelperText>
        )}
        <LoadingButton
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          loading={loading}
        >
          Invia Richiesta
        </LoadingButton>
        <Grid container>
          <Grid item xs>
            <Button component={RouterLink} to="/" startIcon={<ArrowBack />}>
              Torna alla Login
            </Button>
          </Grid>
        </Grid>
        {mutationError && (
          <FormHelperText error>Error :( Riprova</FormHelperText>
        )}
      </Box>
    </Container>
  );
};

export default ForgotPasswordPage;
